import { FC } from "react"
import {
  Dialog,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogClose
} from "./dialog"
import { Button } from "./button";
import { OctagonAlert } from "lucide-react";
import { toast } from "sonner";

type DeleteDialogProps = {
  isShowing: boolean;
  handleDelete: () => void;
  close: () => void;
  itemName: string;
}

export const DeleteDialog: FC<DeleteDialogProps> = ({
  isShowing,
  handleDelete,
  close,
  itemName,
}) => {
  return (
    <Dialog
      open={isShowing}
      onOpenChange={close}
    >
      <DialogTrigger />
      <DialogContent className="w-fit dark:bg-neutral800 dark:border-neutral700">
        <DialogHeader>
          <DialogTitle className="text-2xl flex gap-2 items-center dark:text-neutral100">
            <OctagonAlert width={28} height={28} stroke="#DC2626" />
            <div>Delete: {itemName}</div>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-lg flex flex-col gap-2 items-center dark:text-neutral300">
          <span>Are you sure you want to delete <b>"{itemName}"</b>?</span>
          {itemName.startsWith("Bin ") && (
            <div className="text-sm text-warning900 dark:text-warning200 bg-warning50 dark:bg-warning900/20 border border-warning300 dark:border-warning700 rounded-lg p-3 mt-2">
              <strong>Warning:</strong> This will clear the location reference from all inventory items in this bin.
            </div>
          )}
          <div>This cannot be undone</div>
        </DialogDescription>
        <DialogFooter>
          <div className="flex flex-col gap-2 w-full">
            <DialogClose className="w-full">
              <Button
                variant={"outline"}
                className="w-full rounded"
              >
                cancel
              </Button>
            </DialogClose>
            <Button
              variant={"destructive"}
              onClick={() => {
                try {
                  handleDelete()
                  toast.success(`${itemName} delete successfully`)
                } catch (e) {
                  console.error(e)
                }
                close()
              }}
              className="w-full"
            >
              yes, I'm sure
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>

  )
}
